import o from "./ghl-ui.es1494.js";
import f from "./ghl-ui.es1454.js";
var i = 864e5;
function u(r) {
  f(1, arguments);
  var e = o(r), t = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var a = e.getTime(), m = t - a;
  return Math.floor(m / i) + 1;
}
export {
  u as default
};
